import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import modules from "./modules";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...modules
  ] as RouteRecordRaw[]
})

export default router
